var t = "__lodash_hash_undefined__";
function a(_) {
  return this.__data__.set(_, t), this;
}
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_setCacheAdd.js
// module id = 1500
// module chunks = 41